import React from 'react'

import Button from 'components/Button'
import T from 'components/FormattedMessage'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core'

import facebookIconUrl from 'assets/images/facebook.svg'

interface Props {
  onClick: () => any // tslint:disable-line:no-any
}

const styles = (theme: Theme) => createStyles({
  root: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
    marginLeft: theme.spacing() * 2,
    marginRight: theme.spacing() * 2,
  },
  facebookIcon: {
    width: 24,
    height: 24,
    display: 'block',
  },
  message: {
    marginLeft: theme.spacing() * 2,
    marginRight: theme.spacing() * 2,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const FacebookConnect: React.SFC<InjectedProps> = ({ onClick, classes }) => (
  <div className={classes.root}>
    <Grid container alignItems="center">
      <Grid item container xs={8} alignItems="center">
        <Grid item>
          <img alt="" src={facebookIconUrl} className={classes.facebookIcon} />
        </Grid>
        <Grid item xs>
          <Typography variant="subtitle1" className={classes.message}>
            <T id="friends_facebook_help" />
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={4}>
        <Button fullWidth color="facebook" onClick={onClick}>
          <T id="friends_facebook_connect" />
        </Button>
      </Grid>
    </Grid>
  </div>
)

export default withStyles(styles)(FacebookConnect)
